import { Outlet } from 'react-router-dom';

export default function SegmentsLayout(){

    return (
        <div>
            <Outlet />
        </div>
    )
}